module.exports = __webpack_public_path__ + "img/finish.45fe8b83.png";